<template>
  <section :class="['row', 'row--split', 'row--inverted', {'row--slidup': isInView}]">
    <img :src="require('@/assets/img/contact.jpg')" class="row__image">
    <div class="row__content">
      <header class="row__header">
        <h2 class="row__title row__title--small row__title--nopad">
          Chcesz dowiedzieć się więcej?<br>
          <span class="row__highlight">
            Skon&shy;taktuj się z nami.
          </span>
        </h2>
      </header>
      <div class="contact">
        <div class="contact__content">
        <a href="mailto:contact@caredo.pl">
          <p class="contact__email">
            <img :src="require('@/assets/img/icon-mail.svg')" class="contact__icon">
            contact@caredo.pl
          </p>
        </a>
        <a href="tel:+48500278673">
          <p class="contact__phone">
            <img :src="require('@/assets/img/icon-phone.svg')" class="contact__icon">
            +48 500-278-673
          </p>
        </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'contact',
};
</script>

<style lang="scss" scoped>
.row {
  background-color: $bg-tertiary;
}

.row__content {
  max-width: 710px;

  @media screen and (max-width: 700px) {
    max-width: none;
  }
}

.contact {
  align-items: flex-start;
  display: flex;
  margin: 80px 0 0;
  a{
    text-decoration: none;
    color: black;
  }

  @media screen and (max-width: 700px) {
    margin: 80px 10vw 0;
  }

  @media screen and (max-width: 550px) {
    align-items: center;
    flex-direction: column;
    margin: 80px 0 0;
  }
}

.contact__photo {
  margin-right: 50px;
  max-width: 122px;

  @media screen and (max-width: 700px) {
    margin-right: 30px;
  }

  @media screen and (max-width: 550px) {
    margin-bottom: 30px;
    margin-right: 0;
  }
}

.contact__content {
  text-align: left;
}

.contact__name {
  font-family: $header-font;
  font-size: 1.25em;
  margin: 0 0 30px;
}

.contact__email,
.contact__phone {
  align-items: center;
  display: flex;
  font-size: 1.125em;
  margin: 0 0 20px;
}

.contact__icon {
  margin-right: 20px;
}
</style>
